'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MessageAuthorLabel } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatMessageUtilityClasses } from "./chatMessageClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatMessageAuthorLabel');
const ChatMessageAuthorLabelStyled = styled('span', {
  name: 'MuiChatMessage',
  slot: 'AuthorLabel',
  overridesResolver: (_, styles) => styles.authorLabel
})(({
  theme
}) => ({
  display: 'block',
  fontSize: theme.typography.caption.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  color: (theme.vars || theme).palette.text.secondary,
  marginBottom: theme.spacing(0.25),
  lineHeight: 1.4
}));
const ChatMessageAuthorLabel = /*#__PURE__*/React.forwardRef(function ChatMessageAuthorLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatMessageAuthorLabel'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatMessageUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(MessageAuthorLabel, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      authorLabel: slots?.authorLabel ?? ChatMessageAuthorLabelStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      authorLabel: _extends({
        className: clsx(classes.authorLabel, className)
      }, slotProps?.authorLabel)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatMessageAuthorLabel.displayName = "ChatMessageAuthorLabel";
process.env.NODE_ENV !== "production" ? ChatMessageAuthorLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object
} : void 0;
export { ChatMessageAuthorLabel };